import { useState, useCallback, useEffect, useContext } from "react";
import { useDispatch } from "react-redux";
import { v4 as uuid } from "uuid";
import { findUserPets } from "../../../../../actions";
import { addNotification } from "../../../../../store/slices/ui-slice";
import { UserAppointmentContext } from "../../../context/user-appointment-context";

const useFetchPets = () => {
  const {
    state: { selectedClientAccount },
  } = useContext(UserAppointmentContext);

  const [pets, setPets] = useState<any>(null);
  const [loading, setLoading] = useState(true);
  const dispatch = useDispatch();
  const clientId = selectedClientAccount?.integration_id;

  const fetchPets = useCallback(
    async (clientId: string) => {
      try {
        setLoading(true);
        const response = await findUserPets(clientId);
        setPets(response?.data?.data);
      } catch (err: any) {
        dispatch(
          addNotification({
            id: uuid(),
            type: "error",
            message: err.message || "An unexpected error occurred.",
          })
        );
      } finally {
        setLoading(false);
      }
    },
    [dispatch]
  );

  useEffect(() => {
    fetchPets(clientId);
  }, [clientId, fetchPets]);

  return { pets, loading, fetchPets };
};

export default useFetchPets;
